import { render, staticRenderFns } from "./OrdineMTMDettaglio.vue?vue&type=template&id=bbfd3b84&scoped=true"
import script from "./OrdineMTMDettaglio.vue?vue&type=script&lang=ts"
export * from "./OrdineMTMDettaglio.vue?vue&type=script&lang=ts"
import style0 from "./OrdineMTMDettaglio.vue?vue&type=style&index=0&id=bbfd3b84&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbfd3b84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbfd3b84')) {
      api.createRecord('bbfd3b84', component.options)
    } else {
      api.reload('bbfd3b84', component.options)
    }
    module.hot.accept("./OrdineMTMDettaglio.vue?vue&type=template&id=bbfd3b84&scoped=true", function () {
      api.rerender('bbfd3b84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OrdineMTMDettaglio.vue"
export default component.exports